import React from "react";
import { Badge } from "antd";

interface Props {
  read_at?: string;
  children?: React.ReactNode;
}

const RibbonBadge: React.FC<Props> = ({ read_at, children }) => {
  return <>{read_at ? <>{children}</> : <Badge.Ribbon text="Ny">{children}</Badge.Ribbon>}</>;
};

export default RibbonBadge;
